/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import PopUpModal from "../../PopUpModal/PopUpModal";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { EO_CREATE_EVENT_STEPPER_STEPS_TITLES } from "../../../constants/stepperStepsTitles";
import CreateEventContent1 from "./CreateEventContent1";
import CreateEventContent2 from "./CreateEventContent2";
import CreateEventContent3 from "./CreateEventContent3";
import CreateEventContent4 from "./CreateEventContent4";
import AIEventAssistant from "./AIEventAssistant";
import { useCreateEventContext } from "../../../context/CreateEventContext";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import { useLocation } from "react-router-dom";
import uploadimg from "../../../assets/images/upload.svg";
import ModalRenderer from "./ModalRenderer";
import { validateAndResizeImage } from "../../../utils/imageUtils";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseFunctions/config";

const CreateEventContent = () => {
  const fileInputRef = useRef(null);
  const documentRef = useRef(null);
  const eventDataRef = useRef(null);
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const existingEventData = location.state?.existingEventData || null;

  const { user } = useAuth();
  const UserID = user?.uid;
  const navigate = useNavigate();
  const {
    eventData,
    updateEventData,
    saveEventData,
    resetEventData,
  } = useCreateEventContext();
  
  // Keep ref in sync with latest eventData for use in callbacks
  useEffect(() => {
    eventDataRef.current = eventData;
  }, [eventData]);
  const steps = EO_CREATE_EVENT_STEPPER_STEPS_TITLES;
  const [isLastStep, setIsLastStep] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpModalType, setPopUpModalType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAIAssistant, setShowAIAssistant] = useState(true);
  const [publishedEventId, setPublishedEventId] = useState(null);

  const handleAIApplySuggestions = (aiEvent, flyerFile) => {
    // Build the merged form state — only override fields that AI found
    const merge = (newVal, existing) => (newVal != null && newVal !== '' && !(Array.isArray(newVal) && newVal.length === 0)) ? newVal : existing;

    const updatedFormState = {
      ...formState,
      eventName: merge(aiEvent.eventName, formState.eventName),
      eventType: merge(aiEvent.eventType, formState.eventType),
      location: merge(aiEvent.location, formState.location),
      description: merge(aiEvent.description, formState.description),
      startDate: merge(aiEvent.startDate, formState.startDate),
      startTime: merge(aiEvent.startTime, formState.startTime),
      endDate: merge(aiEvent.endDate || aiEvent.startDate, formState.endDate),
      endTime: merge(aiEvent.endTime, formState.endTime),
      applicationDeadline: merge(aiEvent.applicationDeadline, formState.applicationDeadline),
      loadInDate: merge(aiEvent.loadInDate || aiEvent.startDate, formState.loadInDate),
      loadInTime: merge(aiEvent.loadInTime, formState.loadInTime) || "07:00",
      loadOutDate: merge(aiEvent.loadOutDate || aiEvent.endDate, formState.loadOutDate),
      loadOutTime: merge(aiEvent.loadOutTime, formState.loadOutTime) || "20:00",
    };

    // Flyer becomes cover photo
    if (flyerFile) {
      updatedFormState.eventCoverPhoto = flyerFile;
    }

    setFormState(updatedFormState);

    // Also push all AI fields into the shared event context (used by steps 2-4)
    updateEventData({
      ...eventData,
      eventName: updatedFormState.eventName,
      eventType: updatedFormState.eventType,
      location: updatedFormState.location,
      description: updatedFormState.description,
      startDate: updatedFormState.startDate,
      startTime: updatedFormState.startTime,
      endDate: updatedFormState.endDate,
      endTime: updatedFormState.endTime,
      deadlineDate: updatedFormState.applicationDeadline,
      loadInDate: updatedFormState.loadInDate,
      loadInTime: updatedFormState.loadInTime,
      loadOutDate: updatedFormState.loadOutDate,
      loadOutTime: updatedFormState.loadOutTime,
      // Step 2 fields
      sellerTypes: aiEvent.sellerTypes?.length ? aiEvent.sellerTypes : eventData.sellerTypes,
      sellerCapacity: aiEvent.sellerCapacity || eventData.sellerCapacity || 50,
      registrationFee: aiEvent.registrationFee != null ? aiEvent.registrationFee : eventData.registrationFee,
      addRegistrationFee: aiEvent.registrationFee != null ? aiEvent.registrationFee > 0 : eventData.addRegistrationFee,
      // Website
      eoEventWebsiteURL: merge(aiEvent.website, eventData.eoEventWebsiteURL),
      eventCoverPhoto: flyerFile || eventData.eventCoverPhoto,
      aiGenerated: true,
    });
  };

  // Initialize form state
  const [formState, setFormState] = useState({
    eventName: eventData.eventName || "",
    location: eventData.location || "",
    description: eventData.description || "",
    startDate: eventData.startDate || "",
    startTime: eventData.startTime || "",
    endDate: eventData.endDate || "",
    endTime: eventData.endTime || "",
    recurringEvent: eventData.recurringEvent || false,
    applicationDeadline: eventData.deadlineDate || "",
    loadInDate: eventData.loadInDate || "",
    loadInTime: eventData.loadInTime || "",
    loadOutDate: eventData.loadOutDate || "",
    loadOutTime: eventData.loadOutTime || "",
    eoEventWebsiteURL: eventData.eoEventWebsiteURL || "",
    eoEventFacebookAccount: eventData.socialMediaHandles?.facebook || "",
    eoEventInstagramAccount: eventData.socialMediaHandles?.instagram || "",
    eoEventTikTokAccount: eventData.socialMediaHandles?.tiktok || "",
    selectedRecurringOption: "",
    eventCoverPhoto: eventData.eventCoverPhoto || "",
    eventDocuments: eventData?.eventDocuments || [],
    eventMap: eventData?.eventMap || null,
    eventType: eventData.eventType || "",
  });

  // Pre-fill eventType from EO business profile on first load
  useEffect(() => {
    const loadProfileEventType = async () => {
      if (!UserID || formState.eventType) return;
      try {
        const snap = await getDoc(doc(db, "EO_BusinessProfiles", UserID));
        if (snap.exists()) {
          const profileType = snap.data().eventType;
          if (profileType) {
            setFormState(prev => ({ ...prev, eventType: profileType }));
            updateEventData({ eventType: profileType });
          }
        }
      } catch (err) {
        console.error("Error loading profile event type:", err);
      }
    };
    loadProfileEventType();
  }, [UserID]);

  // Handle step changes
  const handleNext = () => {
    if (!isLastStep) {
      setActiveStep((cur) => {
        const next = cur + 1;
        setIsFirstStep(next === 0);
        setIsLastStep(next === steps.length - 1);
        return next;
      });
    }
  };

  const handlePrevious = () => {
    if (!isFirstStep) {
      setActiveStep((cur) => {
        const prev = cur - 1;
        setIsFirstStep(prev === 0);
        setIsLastStep(prev === steps.length - 1);
        return prev;
      });
    }
  };

  const handleCoverPhotoUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (!file) return;

      // Process and validate the image
      const processedFile = await validateAndResizeImage(file);

      setFormState({
        ...formState,
        eventCoverPhoto: processedFile,
        coverPhotoError: null,
      });

      // Close modal on successful upload
      if (popUpModalType === "upload image") {
        setPopUpModalType(null);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error uploading cover photo:", error);
      setFormState((prev) => ({
        ...prev,
        coverPhotoError: error.message,
      }));
    }
  };

  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      handleCoverPhotoUpload({ target: { files } });
    }
  };

  const handleUploadImageClick = () => {
    if (formState?.eventCoverPhoto) {
      setPopUpModalType(null);
      setIsModalOpen(false);
    }
  };

  const handleEventMapUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormState({
        ...formState,
        eventMap: { fileName: file.name, file: file },
      });
    }
  };

  const handleUploadImageCancel = () => {
    setFormState({
      ...formState,
      eventCoverPhoto: "",
    });
    setPopUpModalType(null);
    setIsModalOpen(false);
  };
  const handleUploadMapCancel = () => {
    setFormState({
      ...formState,
      eventMap: null,
    });
    setPopUpModalType(null);
    setIsModalOpen(false);
  };

  // Initialize form state - reset if new event, load if editing
  useEffect(() => {
    if (existingEventData) {
      updateEventData(existingEventData);
      setFormState({
        eventName: existingEventData.eventName || "",
        location: existingEventData.location || "",
        description: existingEventData.description || "",
        startDate: existingEventData.startDate || "",
        startTime: existingEventData.startTime || "",
        endDate: existingEventData.endDate || "",
        endTime: existingEventData.endTime || "",
        recurringEvent: existingEventData.recurringEvent || false,
        applicationDeadline: existingEventData.deadlineDate || "",
        loadInDate: existingEventData.loadInDate || "",
        loadInTime: existingEventData.loadInTime || "",
        loadOutDate: existingEventData.loadOutDate || existingEventData.loadoutDate || "",
        loadOutTime: existingEventData.loadOutTime || existingEventData.loadoutTime || "",
        eoEventWebsiteURL: existingEventData.eoEventWebsiteURL || "",
        eoEventFacebookAccount: existingEventData.socialMediaHandles?.facebook || "",
        eoEventInstagramAccount: existingEventData.socialMediaHandles?.instagram || "",
        eoEventTikTokAccount: existingEventData.socialMediaHandles?.tiktok || "",
        selectedRecurringOption: "",
        eventCoverPhoto: existingEventData.eventCoverPhoto || "",
        eventDocuments: existingEventData?.eventDocuments || [],
        eventMap: existingEventData?.eventMap || null,
      });
    } else {
      resetEventData();
      setFormState({
        eventName: "",
        location: "",
        description: "",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        recurringEvent: false,
        applicationDeadline: "",
        loadInDate: "",
        loadInTime: "",
        loadOutDate: "",
        loadOutTime: "",
        eoEventWebsiteURL: "",
        eoEventFacebookAccount: "",
        eoEventInstagramAccount: "",
        eoEventTikTokAccount: "",
        selectedRecurringOption: "",
        eventCoverPhoto: "",
        eventDocuments: [],
        eventMap: null,
      });
    }
  }, [existingEventData]);

  const handleOpen = () => {
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setPopUpModalType(null);
    setTimeout(() => {
      navigate("/eo/dashboard");
    }, 150);
  };
  
  const handleCloseModalOnly = () => {
    setIsModalOpen(false);
    setPopUpModalType(null);
  };

  const handleMapUploadClick = () => {
    setIsModalOpen(true);
    setPopUpModalType("upload event map");
  };

  //event documents
  const handleEventDocsUpload = () => {
    setIsModalOpen(true);
    setPopUpModalType("upload event documents");
  };
  const handleUploadEventDocumentsCancel = () => {
    setFormState({
      ...formState,
      eventDocuments: [],
    });
    setPopUpModalType(null);
    setIsModalOpen(false);
  };
  const handleFileUpload = (event) => {
    const files = event.target.files;
    const newDocuments = Array.from(files).map((file) => ({
      fileName: file.name,
      file: file,
    }));

    setFormState((prev) => ({
      ...prev,
      eventDocuments: [...prev.eventDocuments, ...newDocuments],
    }));
  };

  const handleSaveForLater = () => {
    setPopUpModalType("saveForLaterConfirmation"); // Set modal type
    handleOpen(); // Open the modal
  };

  const handleSaveDraft = async () => {
    setIsLoading(true);
    // Use ref to get the most current eventData (avoids stale closure issues)
    const currentEventData = eventDataRef.current || eventData;
    const response = await saveEventData(UserID, true, currentEventData);

    if (response && response.success) {
      setPopUpModalType("saveDraftSuccess");
    } else {
      setPopUpModalType("saveDraftFailure");
    }
    setIsLoading(false);
    handleOpen();
  };

  const handlePublishEvent = async () => {
    setIsLoading(true);
    // Use ref to get the most current eventData
    const currentEventData = eventDataRef.current || eventData;
    const response = await saveEventData(UserID, false, currentEventData);

    if (response && response.success) {
      setPublishedEventId(response.eventId || null);
      setPopUpModalType("eventPublishedSuccess");
      setIsLoading(false);
    } else if (response && response.limitReached) {
      // Auto-save as draft so the user doesn't lose their work
      if (!currentEventData.eventId) {
        await saveEventData(UserID, true, currentEventData);
      }
      setPopUpModalType("eventLimitReached");
      setIsLoading(false);
    } else {
      setPopUpModalType("eventPublishedFailure");
      setIsLoading(false);
    }
  };
  const handleSaveCreateEvent = () => {
    handleOpen();
    setPopUpModalType("eventPublishConfirmation");
  };
  const handleGoToDashboard = () => {
    resetEventData();
    navigate("/eo/dashboard");
  };
  const handleShareEvent = () => {
    setIsLoading(true);
    setPopUpModalType("shareEvent");
    setIsLoading(false);
  };

  if (!user) return null;

  return (
    <>
      <PopUpModal
        open={isModalOpen}
        handleClose={handleClose}
        popUpModalType={popUpModalType}
      >
        {!isLoading ? (
          <ModalRenderer
            popUpModalType={popUpModalType}
            formState={formState}
            isModalOpen={isModalOpen}
            publishedEventId={publishedEventId}
            isDragging={isDragging}
            fileInputRef={fileInputRef}
            documentRef={documentRef}
            handleClose={handleClose}
            handleCloseModalOnly={handleCloseModalOnly}
            handlePublishEvent={handlePublishEvent}
            handleGoToDashboard={handleGoToDashboard}
            handleShareEvent={handleShareEvent}
            handleSaveDraft={handleSaveDraft}
            handleSaveForLater={handleSaveForLater}
            handleCancel={handleClose}
            handleUploadImageClick={handleUploadImageClick}
            handleUploadImageCancel={handleUploadImageCancel}
            handleCoverPhotoUpload={handleCoverPhotoUpload}
            handleDragOver={handleDragOver}
            handleDragLeave={handleDragLeave}
            handleDrop={handleDrop}
            handleUploadMapCancel={handleUploadMapCancel}
            handleEventMapUpload={handleEventMapUpload}
            handleUploadEventDocumentsCancel={handleUploadEventDocumentsCancel}
            handleFileUpload={handleFileUpload}
            setIsModalOpen={setIsModalOpen}
            setPopUpModalType={setPopUpModalType}
          />
        ) : (
          <ModalLoadingState />
        )}
      </PopUpModal>
      {/* AI Event Assistant Modal */}
      <AIEventAssistant
        isOpen={showAIAssistant}
        onClose={() => setShowAIAssistant(false)}
        onApplySuggestions={handleAIApplySuggestions}
        currentFormState={formState}
      />
      
      {/* Create event form */}
      <div className="w-full mx-auto">
        <div className="w-full flex flex-col items-center justify-center">
          {/* Clean Header with Cancel */}
          <div className="w-full max-w-4xl px-6 pt-6 pb-4 flex items-center justify-between">
            <button
              onClick={() => {
                setPopUpModalType("cancel event application");
                setIsModalOpen(true);
              }}
              className="inline-flex items-center gap-1.5 text-sm text-grey-500 hover:text-grey-700 transition-colors group"
            >
              <svg className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              <span>Back to Events</span>
            </button>
            {!showAIAssistant && (
              <button
                onClick={() => setShowAIAssistant(true)}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 bg-primary-50 hover:bg-primary-100 border border-primary-200 px-3 py-1.5 rounded-lg transition-colors"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Try AI Assistant
              </button>
            )}
          </div>
          
          {/* Form Content */}
          <div className="w-full">
            {activeStep === 0 && (
              <CreateEventContent1
                handleContinue={handleNext}
                handleCancel={handleClose}
                handleSaveForLater={handleSaveForLater}
                formState={formState}
                setFormState={setFormState}
                handleUploadImageClick={() => {
                  setIsModalOpen(true);
                  setPopUpModalType("upload image");
                }}
                UserID={UserID}
                eventData={eventData}
                updateEventData={updateEventData}
              />
            )}
            {activeStep === 1 && (
              <CreateEventContent2
                handleContinue={handleNext}
                handlePrevious={handlePrevious}
                handleSaveForLater={handleSaveForLater}
              />
            )}
            {activeStep === 2 && (
              <CreateEventContent3
                handleContinue={handleNext}
                handlePrevious={handlePrevious}
                handleSaveForLater={handleSaveForLater}
              />
            )}
            {activeStep === 3 && (
              <CreateEventContent4
                formState={formState}
                eventData={eventData}
                updateEventData={updateEventData}
                saveEventData={saveEventData}
                setFormState={setFormState}
                handleContinue={handleSaveCreateEvent}
                handlePrevious={handlePrevious}
                handleSaveForLater={handleSaveForLater}
                handleUploadClick={handleMapUploadClick}
                handleEventDocsUpload={handleEventDocsUpload}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateEventContent;

export const DocumentUpload = ({ isDragging, title, error }) => (
  <div
    className={`flex flex-col items-center justify-center w-full h-56 border-2 ${
      error
        ? "border-red-500"
        : isDragging
        ? "border-primary-500"
        : "border-dashed border-grey-300"
    } rounded-lg cursor-pointer hover:border-grey-500 p-6`}
  >
    <img src={uploadimg} alt="fileUploadCloud" />
    <div className="flex flex-col items-center justify-center pt-5 pb-6 gap-2">
      <p className="mb-2 text-sm text-grey-900">
        <span className="font-medium">{title}</span>
      </p>
      <p className="text-xs text-center font-normal leading-[20px] text-grey-900">
        Drag files into this space, or click to browse files to upload. Supports
        .png, .jpg files. Recommended size: 1200px by 628px. Max size 5MB.
      </p>
      {error && <p className="text-xs text-red-500 mt-2">{error}</p>}
    </div>
  </div>
);
